import { UiKeys } from '@voicedojo/backend-types';
import { t } from '$lib/i18n';

const REGIONS: Record<string, string> = {
  na: UiKeys.HomeMove.Region.Na,
  au: UiKeys.HomeMove.Region.Au,
  sg: UiKeys.HomeMove.Region.Sg,
};

/** A cell's name for people. A cell this build has no name for still reads as its id. */
export function regionName(cell: string): string {
  const key = REGIONS[cell];
  return key ? t(key) : cell.toUpperCase();
}
